<template>
  <b-modal
    ref="modal"
    hide-footer
    centered
    title="Set Icon"
  >
    <b-form @submit.prevent="save">
      <b-form-group>
        <b-input-group>
          <template v-slot:append>
            <b-input-group-text>
              <icon name="search" />
            </b-input-group-text>
          </template>
          <b-form-input v-model="searchKey" />
        </b-input-group>
      </b-form-group>
      <b-form-group>
        <ul class="tab-icon-list">
          <li
            v-for="(name, idx) in iconList"
            :key="idx"
          >
            <a href="#" @click="selectIcon(name)">
              <icon :name="name" />
            </a>
          </li>
        </ul>
      </b-form-group>
      <b-form-group v-if="iconName">
        <div class="tab-icon-holder">
          <span :style="`color: ${iconColor};`">
            <icon :name="iconName" scale="1.5" />
          </span>
        </div>
      </b-form-group>
      <b-form-group
        v-if="iconName"
        class="tab-icon-color"
      >
        <color-picker
          :color="iconColor"
          @changeColor="changeColor"
        />
      </b-form-group>
      <div>
        <b-button type="submit" variant="primary" :disabled="inProcess">
          <span>Save</span>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
import { find } from 'lodash'
// components
import colorPicker from '@caohenghu/vue-colorpicker'
// helpers
import eventBus from '@/helpers/event-bus'
// services
import db from '@/services/db'
import icons from './icons'

export default {
  props: ['tabs'],
  components: {
    colorPicker
  },
  data() {
    return {
      inProcess: false,
      iconName: null,
      iconColor: 'rgba(255, 255, 255, 1)',
      searchKey: null
    }
  },
  computed: {
    ...mapState([
      'currentTab',
    ]),
    iconList() {
      const result = []

      for (let idx in icons) {
        const icon = icons[idx]

        if (this.searchKey) {
          if (icon.match(new RegExp(this.searchKey, 'i'))) result.push(icon)
        } else {
          result.push(icon)
        }
      }

      return result
    }
  },
  methods: {
    open() {
      const tab = find(this.tabs, { key: this.currentTab })

      if (tab && tab.icon) {
        this.iconName = tab.icon.name || null
        this.iconColor = tab.icon.color || null
      }

      if (this.$refs.modal) this.$refs.modal.show()
    },
    close() {
      if (this.$refs.modal) this.$refs.modal.hide()
    },
    async save() {
      const data = {
        tab: this.currentTab,
        name: this.iconName,
        color: this.iconColor
      }

      await db.tabs.setIcon(data)

      this.close()
    },
    selectIcon(iconName) {
      this.iconName = iconName
    },
    changeColor(color) {
      const {rgba: {r, g, b, a}} = color
      this.iconColor = `rgba(${r}, ${g}, ${b}, ${a})`
    }
  },
  created() {
    eventBus.$on('showTabIconModal', () => {
      this.open()
    })
  }
}
</script>

<style lang="scss">
@import '~$scss/globals';

.tab-icon-list {
  min-height: 35px;
  max-height: 200px;
  @include resetList;
  border: 1px solid #dee2e6;
  border-radius: .25rem;
  padding: 0 7px;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  li {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 10%;
    height: 35px;
    svg {
      vertical-align: -2px;
    }
  }
}
.tab-icon-color > div > div {
  width: 100% !important;
}
.tab-icon-holder {
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #dee2e6;
  border-radius: .25rem;
  background: #5940cc;
}
</style>
